import { loggedInUserData } from "@modules/index";
import { combineLatest } from "rxjs";
import { currentComponentPageBasedPermissionsSelector$ } from "../layouts";
import { prepareDynamicTableTabsFromPermissions } from "./functions.utils";
import { LoggedInUserModel } from "./models";

const combineLatestNgrxStoreData = (store) => {
  return combineLatest([
    store.select(loggedInUserData),
    store.select(currentComponentPageBasedPermissionsSelector$)
  ]);
}
const handleNgrxStoreData = (callback: (response: any) => void, store) => {
  combineLatestNgrxStoreData(store).subscribe(callback);
}

const processStoreData = (response: any, primengTableConfigProperties: any, permissionKey: string) => {
  const loggedInUserData = new LoggedInUserModel(response[0]);
  const permission = permissionKey ? response[1][permissionKey] : null;
  let prepareDynamicTableTabsFromPermissionsObj: any;
  if (permission) {
    prepareDynamicTableTabsFromPermissionsObj = prepareDynamicTableTabsFromPermissions(primengTableConfigProperties, permission);
  }
  return { primengTableConfigProperties: permissionKey ? prepareDynamicTableTabsFromPermissionsObj?.primengTableConfigProperties : null, loggedInUserData: loggedInUserData };
}
export { handleNgrxStoreData, processStoreData };